import { VersionT } from "../../../models/models";

const MXF_FILE_FORMAT = "MXF";

function getAdIdsFromVersions(versions: VersionT[], mxfOnly?: boolean) {
  if (!versions || !versions.length) return [];

  const adIds = versions
    .filter(({ fileFormat }) =>
      mxfOnly ? fileFormat === MXF_FILE_FORMAT : true
    )
    .map(({ AdId }) => AdId);

  return adIds;
}

export default getAdIdsFromVersions;
